import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { isSameUrlFilters } from '../lib/urlFilters';
import { hasMissingLabels, hydrateFilterLabels } from '../lib/hydrateFilterLabels';

export const useFilterLabelHydration = ({ filters, setFilters, defaultFilters }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!hasMissingLabels(filters)) return;

    let isCancelled = false;

    hydrateFilterLabels({ filters, navigate, queryClient }).then((hydrated) => {
      if (isCancelled || hydrated === filters) return;
      setFilters((prev) => (isSameUrlFilters(prev, hydrated, defaultFilters) ? hydrated : prev));
    });

    return () => {
      isCancelled = true;
    };
  }, [filters]);
};
